import { ConstraintsAndPreferences } from '.'
export const calculateConstraintsAndPreference = (schedule, path) => {

    switch (path) {
        case ConstraintsAndPreferences.Constants.JOINT_CLASSES:
            //jointClasses
            //all jointClasses considered as Constraint
            let jointClassesConstraintCount = schedule.jointClasses.length;

            schedule.constraintCount = computeCount(schedule.constraintCount,
                schedule.jointClassesConstraintCount, jointClassesConstraintCount);

            schedule.jointClassesConstraintCount = jointClassesConstraintCount

            return schedule

        case ConstraintsAndPreferences.Constants.MULTI_PERIODS:
            //multiPeriods
            let multiPeriodsConstraintCount = 0
            schedule.multiPeriods.map(function (period) {
                period.preferences.map(function (preference) {
                    //If noOfStandardPeriods>1 then it is Constraint
                    if (preference.noOfStandardPeriods > 1) {
                        multiPeriodsConstraintCount++
                    }
                })
            })

            schedule.constraintCount = computeCount(schedule.constraintCount,
                schedule.multiPeriodsConstraintCount, multiPeriodsConstraintCount)

            schedule.multiPeriodsConstraintCount = multiPeriodsConstraintCount

            return schedule

        case ConstraintsAndPreferences.Constants.TEACHERS_AND_TAS_FOR_SUBJECTS:
            //numberOfTeachersAndTAsForSubjects
            let numberOfTeachersAndTAsForSubjectsConstraintCount = 0
            schedule.numberOfTeachersAndTAsForSubjects.map(function (subject) {
                //If teachers>1 then it is Constraint
                if (subject.teachers > 1) {
                    numberOfTeachersAndTAsForSubjectsConstraintCount++
                }
                //If TAs>1 then it is Constraint
                if (subject.TAs > 0) {
                    numberOfTeachersAndTAsForSubjectsConstraintCount++
                }
            })
            schedule.constraintCount = computeCount(schedule.constraintCount,
                schedule.numberOfTeachersAndTAsForSubjectsConstraintCount,
                numberOfTeachersAndTAsForSubjectsConstraintCount)

            schedule.numberOfTeachersAndTAsForSubjectsConstraintCount = numberOfTeachersAndTAsForSubjectsConstraintCount

            return schedule

        case ConstraintsAndPreferences.Constants.TEACHERS_AND_TAS_FOR_ELECTIVES:

            //numberOfTeachersAndTAsForElectives
            let numberOfTeachersAndTAsForElectivesConstraintCount = 0
            schedule.fixedTeachersAndTAsForSubjects.map(function (elective) {
                //electives will have no of subject>1
                if (elective.teachersAndTAs != undefined) {
                    elective.teachersAndTAs.map(function (subject) {
                        //If teachers>1 then it is Constraint
                        if (subject.teachers > 1) {
                            numberOfTeachersAndTAsForElectivesConstraintCount++
                        }
                        //If TAs>1 then it is Constraint
                        if (subject.TAs > 0) {
                            numberOfTeachersAndTAsForElectivesConstraintCount++
                        }

                    })
                }
            })
            schedule.constraintCount = computeCount(schedule.constraintCount,
                schedule.numberOfTeachersAndTAsForElectivesConstraintCount, numberOfTeachersAndTAsForElectivesConstraintCount);

            schedule.numberOfTeachersAndTAsForElectivesConstraintCount = numberOfTeachersAndTAsForElectivesConstraintCount

            return schedule

        case ConstraintsAndPreferences.Constants.FIXED_TEACHERS_AND_TAS_FOR_SUBJECTS:
            //fixedTeachersAndTAsForSubjects
            let fixedTeachersAndTAsForSubjectsPreferenceCount = 0
            let fixedTeachersAndTAsForSubjectsConstraintCount = 0
            schedule.fixedTeachersAndTAsForSubjects.map(function (subject) {
                //If teachers array have fixed array length >0 then it is Constraint
                if (subject.teachers.fixed.length > 0) {
                    fixedTeachersAndTAsForSubjectsConstraintCount++
                }
                //If teachers array have preferred array length >0 then it is Constraint
                if (subject.teachers.preferred.length > 0) {
                    fixedTeachersAndTAsForSubjectsPreferenceCount++
                }
                //If TAs array have fixed array length >0 then it is Constraint
                if (subject.TAs.fixed.length > 0) {
                    fixedTeachersAndTAsForSubjectsConstraintCount++
                }
                //If TAs array have preferred array length >0 then it is Constraint
                if (subject.TAs.preferred.length > 0) {
                    fixedTeachersAndTAsForSubjectsPreferenceCount++
                }
            })
            schedule.constraintCount = computeCount(schedule.constraintCount,
                schedule.fixedTeachersAndTAsForSubjectsConstraintCount,
                fixedTeachersAndTAsForSubjectsConstraintCount);

            schedule.fixedTeachersAndTAsForSubjectsConstraintCount = fixedTeachersAndTAsForSubjectsConstraintCount

            schedule.preferenceCount = computeCount(schedule.preferenceCount,
                schedule.fixedTeachersAndTAsForSubjectsPreferenceCount,
                fixedTeachersAndTAsForSubjectsPreferenceCount)

            schedule.fixedTeachersAndTAsForSubjectsPreferenceCount = fixedTeachersAndTAsForSubjectsPreferenceCount

            return schedule

        case ConstraintsAndPreferences.Constants.FIXED_TEACHERS_AND_TAS_FOR_ELECTIVES:
            //fixedTeachersAndTAsForElectives
            let fixedTeachersAndTAsForElectivesPreferenceCount = 0
            let fixedTeachersAndTAsForElectivesConstraintCount = 0
            schedule.fixedTeachersAndTAsForSubjects.map(function (elective) {
                //electives will have no of subject>1
                if (elective.teachersAndTAs != undefined) {
                    elective.teachersAndTAs.map(function (subject) {
                        //If teachers array have fixed array length >0 then it is Constraint
                        if (subject.teachers.fixed.length > 0) {
                            fixedTeachersAndTAsForElectivesConstraintCount++
                        }
                        //If teachers array have preferred array length >0 then it is Constraint
                        if (subject.teachers.preferred.length > 0) {
                            fixedTeachersAndTAsForElectivesPreferenceCount++
                        }
                        //If TAs array have fixed array length >0 then it is Constraint
                        if (subject.TAs.fixed.length > 0) {
                            fixedTeachersAndTAsForElectivesConstraintCount++
                        }
                        //If TAs array have preferred array length >0 then it is Constraint
                        if (subject.TAs.preferred.length > 0) {
                            fixedTeachersAndTAsForElectivesPreferenceCount++
                        }
                    })
                }

            })

            schedule.constraintCount = computeCount(schedule.constraintCount,
                schedule.fixedTeachersAndTAsForElectivesConstraintCount,
                fixedTeachersAndTAsForElectivesConstraintCount);

            schedule.fixedTeachersAndTAsForElectivesConstraintCount = fixedTeachersAndTAsForElectivesConstraintCount

            schedule.preferenceCount = computeCount(schedule.preferenceCount,
                schedule.fixedTeachersAndTAsForElectivesPreferenceCount,
                fixedTeachersAndTAsForElectivesPreferenceCount)

            schedule.fixedTeachersAndTAsForElectivesPreferenceCount = fixedTeachersAndTAsForElectivesPreferenceCount

            return schedule

        case ConstraintsAndPreferences.Constants.PREFERRED_PERIODS:
            //preferredPeriods
            //all preferredPeriods considered preference
            let preferredPeriodsPreferenceCount = schedule.preferredPeriods.length
            schedule.preferenceCount = computeCount(schedule.preferenceCount,
                schedule.preferredPeriodsPreferenceCount,
                preferredPeriodsPreferenceCount);

            schedule.preferredPeriodsPreferenceCount = preferredPeriodsPreferenceCount

            return schedule

        case ConstraintsAndPreferences.Constants.REQUIRED_SHARED_ROOM_FOR_SUBJECTS:
            //sharedRoomsForSubjects
            let sharedRoomsForSubjectsConstraintCount = 0
            schedule.sharedRoomsForSubjects.map(function (subject) {
                //If subject have room array length >0 then it is Constraint
                if (subject.room.length > 0) {
                    sharedRoomsForSubjectsConstraintCount++
                }
            })
            schedule.constraintCount = computeCount(schedule.constraintCount,
                schedule.sharedRoomsForSubjectsConstraintCount,
                sharedRoomsForSubjectsConstraintCount);

            schedule.sharedRoomsForSubjectsConstraintCount = sharedRoomsForSubjectsConstraintCount

            return schedule

        case ConstraintsAndPreferences.Constants.REQUIRED_SHARED_ROOM_FOR_ELECTIVES:
            //sharedRoomsForElectives
            let sharedRoomsForElectivesConstraintCount = 0
            schedule.sharedRoomsForElectives.map(function (elective) {
                //electives will have no of subject>1
                if (elective.subjects != undefined) {
                    elective.subjects.map(function (subject) {
                        //If subjects array have room array length >0 then it is Constraint
                        if (subject.rooms.length > 0) {
                            sharedRoomsForElectivesConstraintCount++
                        }
                    })
                }

            })
            schedule.constraintCount = computeCount(schedule.constraintCount,
                schedule.sharedRoomsForElectivesConstraintCount,
                sharedRoomsForElectivesConstraintCount);

            schedule.sharedRoomsForElectivesConstraintCount = sharedRoomsForElectivesConstraintCount

            return schedule
    }

}

export const computeCount = (count, oldValue, newValue) => {
    return ((count - oldValue) + newValue)
}

